import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  FLOWCHART_CONFIG_ADD_NODE_ENDED_EVENT,
  FLOWCHART_CONFIG_ADD_NODE_STARTED_EVENT,
  FLOWCHART_CONFIG_DELETE_NODE_ENDED_EVENT,
  FLOWCHART_CONFIG_DELETE_NODE_STARTED_EVENT,
} from 'performance/processProcessesEvents';
import type {EventMetadata} from 'performance/ProfilerConstants';

import type {StaticFlowchartNodeData} from '../processFlowchartConfigEditorNodeTypes';
import {
  isInteractivePlaceholderNode,
  isStaticPlaceholderNodeData,
} from '../processFlowchartConfigEditorNodeTypes';
import {FlowchartNodeChangeType} from '../processFlowchartConfigEditorUtils';
import type {FlowchartNodeChange} from '../processFlowchartConfigEditorUtils';

export interface NodeChangeProfilerFlags {
  hasNonPlaceholderNodeAdd: boolean;
  hasNonPlaceholderNodeRemove: boolean;
}

export function detectProfilerNodeChanges(
  nodeChanges: ReadonlyArray<FlowchartNodeChange>,
  nodesStaticData: ReadonlyArray<StaticFlowchartNodeData>
): NodeChangeProfilerFlags {
  const hasNonPlaceholderNodeAdd = nodeChanges.some(
    (c) => c.type === FlowchartNodeChangeType.ADD && c.item != null && !isInteractivePlaceholderNode(c.item)
  );
  const hasNonPlaceholderNodeRemove = nodeChanges.some((c) => {
    if (c.type !== FlowchartNodeChangeType.REMOVE) {
      return false;
    }
    const nodeData = nodesStaticData.find((n) => n.id === c.id);
    return nodeData != null && !isStaticPlaceholderNodeData(nodeData);
  });
  return {hasNonPlaceholderNodeAdd, hasNonPlaceholderNodeRemove};
}

export function logNodeChangeProfilerEvents(
  {hasNonPlaceholderNodeAdd, hasNonPlaceholderNodeRemove}: NodeChangeProfilerFlags,
  phase: 'start' | 'end',
  metadata?: EventMetadata
): void {
  if (phase === 'start') {
    if (hasNonPlaceholderNodeAdd) {
      logProfilerTimingEvent(FLOWCHART_CONFIG_ADD_NODE_STARTED_EVENT);
    }
    if (hasNonPlaceholderNodeRemove) {
      logProfilerTimingEvent(FLOWCHART_CONFIG_DELETE_NODE_STARTED_EVENT);
    }
  } else {
    if (hasNonPlaceholderNodeAdd) {
      logProfilerTimingEvent(FLOWCHART_CONFIG_ADD_NODE_ENDED_EVENT, metadata);
    }
    if (hasNonPlaceholderNodeRemove) {
      logProfilerTimingEvent(FLOWCHART_CONFIG_DELETE_NODE_ENDED_EVENT, metadata);
    }
  }
}
